import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AuthenticationService } from '../authentication/authentication.service';
import { UtilitiesService } from '../utilities-service/utilities.service';
import { map, Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { PublicCardEncoderSettingModel } from 'src/app/shared/models/public-card-encoder-setting-model';
import { FiltersModel } from 'src/app/shared/models/FiltersModel.model';
import { CardEncoderSettingsListModel } from 'src/app/shared/models/card-encoder-settings-list-model';

@Injectable({
  providedIn: 'root'
})
export class CardEncoderSettingService {

  private userToken: string;

  constructor(private http: HttpClient, private authenticationService: AuthenticationService,
    private utilitiesService: UtilitiesService) {
    const $this = this;
    $this.userToken = $this.authenticationService.currentUserValue.Token;
  }
  public GetAllColumnNames(): Observable<string[]> {
    const $this = this;
    var header = {
      headers: new HttpHeaders()
        .set('Authorization', 'Bearer ' + $this.userToken)
    }
    return $this.http.get<string[]>(environment.apiUrl + 'api/v1/CardEncoderSetting/GetAllColumnNames', header).pipe();
  }

  public GetCardEncoderSettingById(id: number): Observable<PublicCardEncoderSettingModel> {
    const $this = this;
    var header = {
      headers: new HttpHeaders()
        .set('Authorization', 'Bearer ' + $this.userToken)
    }
    return $this.http.get<PublicCardEncoderSettingModel>(environment.apiUrl + 'api/v1/CardEncoderSetting/' + id, header).pipe(map(returnPmsSetting => {
      return returnPmsSetting;
    }));
  }

  public GetAllCardEncoderSettings(filterParameters: FiltersModel): Observable<CardEncoderSettingsListModel> {
    const $this = this;
    var header = {
      headers: new HttpHeaders()
        .set('Authorization', 'Bearer ' + $this.userToken)
    }

    return $this.http.post<CardEncoderSettingsListModel>(environment.apiUrl + 'api/v1/CardEncoderSetting/GetAllCardEncoderSettings', filterParameters, header).pipe();
  }

  public SaveOrUpdateCardEncoderSetting(model: PublicCardEncoderSettingModel): Observable<PublicCardEncoderSettingModel> {
    const $this = this;
    var header = {
      headers: new HttpHeaders()
        .set('Authorization', 'Bearer ' + $this.userToken)
    }

    model.cardEncodeSettings = $this.utilitiesService.convertKeysToFirstLetterUppercase(model.cardEncodeSettings);

    const convertedData = $this.utilitiesService.convertKeysToFirstLetterUppercase(model);

    const postData = convertedData;

    return $this.http.post<PublicCardEncoderSettingModel>(environment.apiUrl + 'api/v1/CardEncoderSetting', postData, header).pipe();
  }

  public DeleteListOfCardEncoderSetting(listOfDocuments: any[]): Observable<any> {
    const $this = this;
    let listToDelete = JSON.stringify(listOfDocuments);
    const options = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }).set('Authorization', 'Bearer ' + $this.userToken),
      body: listOfDocuments,
    };
    return $this.http.delete<any>(environment.apiUrl + 'api/v1/CardEncoderSetting', options).pipe();
  }
}
